// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    CoverMyMedsV1ClientGeneratedEnrollmentRequestModel,
    CoverMyMedsV1ClientGeneratedPriorAuthorizationProcessStatusRequestModel,
    DigitalPaymentV1ClientGeneratedWebhook,
    GatewayError,
    PharmacyscriptV1ClientGeneratedUpdateCustomerByOrderBodyModel,
    TCApiGatewayControllersModelsAddressVerificationModel,
    TCApiGatewayControllersModelsClsInboundEnrollment,
    TCApiGatewayControllersModelsRequestTypesGetPortalConfigurationRequestModel,
    TCApiGatewayControllersModelsRequestTypesGetProgramRequest,
    TCApiGatewayControllersModelsRequestTypesGetSiteAccountsRequestModel,
    TCApiGatewayControllersModelsRequestTypesPayorAccountLookupRequest,
    TCApiGatewayControllersModelsRequestTypesPharmacySearchRequestModel,
    TCApiGatewayControllersModelsRequestTypesPrescriberSearchRequestModel,
    TCApiGatewayControllersModelsRequestTypesSaveAddressRequestModel,
    TCApiGatewayControllersModelsRequestTypesTextingInternalEndpointsRequest,
    TcsAncillaryV1ClientGeneratedTcNewLeafRefillOrderValidationRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeSwaggerIgnoreApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesSaveAddressRequestModel 
     */
    public async addressSaveAddress (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesSaveAddressRequestModel?: TCApiGatewayControllersModelsRequestTypesSaveAddressRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Address/saveAddress';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesSaveAddressRequestModel, "TCApiGatewayControllersModelsRequestTypesSaveAddressRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsAddressVerificationModel 
     */
    public async addressVerifyAddress (xProgramId?: string, tCApiGatewayControllersModelsAddressVerificationModel?: TCApiGatewayControllersModelsAddressVerificationModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Address/verifyAddress';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsAddressVerificationModel, "TCApiGatewayControllersModelsAddressVerificationModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesGetSiteAccountsRequestModel 
     */
    public async adminGetSiteAccounts (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesGetSiteAccountsRequestModel?: TCApiGatewayControllersModelsRequestTypesGetSiteAccountsRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Admin/getSiteAccounts';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesGetSiteAccountsRequestModel, "TCApiGatewayControllersModelsRequestTypesGetSiteAccountsRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tcsAncillaryV1ClientGeneratedTcNewLeafRefillOrderValidationRequestModel 
     */
    public async ciscoNewLeafRefillOrderValidation (xProgramId?: string, tcsAncillaryV1ClientGeneratedTcNewLeafRefillOrderValidationRequestModel?: TcsAncillaryV1ClientGeneratedTcNewLeafRefillOrderValidationRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Cisco/newLeafRefillOrderValidation';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tcsAncillaryV1ClientGeneratedTcNewLeafRefillOrderValidationRequestModel, "TcsAncillaryV1ClientGeneratedTcNewLeafRefillOrderValidationRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesTextingInternalEndpointsRequest 
     */
    public async ciscoTextingInternal (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesTextingInternalEndpointsRequest?: TCApiGatewayControllersModelsRequestTypesTextingInternalEndpointsRequest): Promise<AxiosResponse> {
        const _url_ = '/netApi/Cisco/textingInternal';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesTextingInternalEndpointsRequest, "TCApiGatewayControllersModelsRequestTypesTextingInternalEndpointsRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param body 
     */
    public async clsEnroll (xProgramId?: string, body?: any): Promise<AxiosResponse> {
        const _url_ = '/netApi/Cls/enroll';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(body, "any"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsClsInboundEnrollment 
     */
    public async clsEnrollPatient (xProgramId?: string, tCApiGatewayControllersModelsClsInboundEnrollment?: TCApiGatewayControllersModelsClsInboundEnrollment): Promise<AxiosResponse> {
        const _url_ = '/netApi/Cls/enrollPatient';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsClsInboundEnrollment, "TCApiGatewayControllersModelsClsInboundEnrollment"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param coverMyMedsV1ClientGeneratedEnrollmentRequestModel 
     */
    public async cmmHubEnrollment (xProgramId?: string, coverMyMedsV1ClientGeneratedEnrollmentRequestModel?: CoverMyMedsV1ClientGeneratedEnrollmentRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Cmm/hubEnrollment';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(coverMyMedsV1ClientGeneratedEnrollmentRequestModel, "CoverMyMedsV1ClientGeneratedEnrollmentRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param coverMyMedsV1ClientGeneratedPriorAuthorizationProcessStatusRequestModel 
     */
    public async cmmStatusUpdate (xProgramId?: string, coverMyMedsV1ClientGeneratedPriorAuthorizationProcessStatusRequestModel?: CoverMyMedsV1ClientGeneratedPriorAuthorizationProcessStatusRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Cmm/statusUpdate';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(coverMyMedsV1ClientGeneratedPriorAuthorizationProcessStatusRequestModel, "CoverMyMedsV1ClientGeneratedPriorAuthorizationProcessStatusRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param payload 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async dataPublish (payload?: string, xProgramId?: string): Promise<AxiosResponse> {
        const _url_ = '/netApi/Data/publish';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (payload !== undefined) {
            _params_['payload'] = Serializer.serialize(payload, "string");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param digitalPaymentV1ClientGeneratedWebhook 
     */
    public async digitalPaymentConcoursePayment (xProgramId?: string, digitalPaymentV1ClientGeneratedWebhook?: DigitalPaymentV1ClientGeneratedWebhook): Promise<AxiosResponse> {
        const _url_ = '/netApi/DigitalPayment/concoursePayment';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(digitalPaymentV1ClientGeneratedWebhook, "DigitalPaymentV1ClientGeneratedWebhook"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param id 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async getCustomerByOrderid (id: string, xProgramId?: string): Promise<AxiosResponse> {
        const _url_ = '/netApi/PharmacyScript/getCustomerByOrder/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getCustomerByOrderid.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param rxNumber 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async newLeafFillStatusrxNumber (rxNumber: string, xProgramId?: string): Promise<AxiosResponse> {
        const _url_ = '/netApi/Cisco/newLeafFillStatus/{rxNumber}'
            .replace('{' + 'rxNumber' + '}', encodeURIComponent(String(rxNumber)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'rxNumber' is not null or undefined
        if (rxNumber === null || rxNumber === undefined) {
            throw new Error('Required parameter rxNumber was null or undefined when calling newLeafFillStatusrxNumber.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesPharmacySearchRequestModel 
     */
    public async npiPharmacySearch (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesPharmacySearchRequestModel?: TCApiGatewayControllersModelsRequestTypesPharmacySearchRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Npi/PharmacySearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesPharmacySearchRequestModel, "TCApiGatewayControllersModelsRequestTypesPharmacySearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesPrescriberSearchRequestModel 
     */
    public async npiPrescriberSearch (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesPrescriberSearchRequestModel?: TCApiGatewayControllersModelsRequestTypesPrescriberSearchRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Npi/PrescriberSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesPrescriberSearchRequestModel, "TCApiGatewayControllersModelsRequestTypesPrescriberSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesPayorAccountLookupRequest 
     */
    public async payorMedicalCoverage (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesPayorAccountLookupRequest?: TCApiGatewayControllersModelsRequestTypesPayorAccountLookupRequest): Promise<AxiosResponse> {
        const _url_ = '/netApi/Payor/medicalCoverage';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesPayorAccountLookupRequest, "TCApiGatewayControllersModelsRequestTypesPayorAccountLookupRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesPayorAccountLookupRequest 
     */
    public async payorPharmacyCoverage (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesPayorAccountLookupRequest?: TCApiGatewayControllersModelsRequestTypesPayorAccountLookupRequest): Promise<AxiosResponse> {
        const _url_ = '/netApi/Payor/pharmacyCoverage';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesPayorAccountLookupRequest, "TCApiGatewayControllersModelsRequestTypesPayorAccountLookupRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesGetPortalConfigurationRequestModel 
     */
    public async porticoGetPortalConfiguration (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesGetPortalConfigurationRequestModel?: TCApiGatewayControllersModelsRequestTypesGetPortalConfigurationRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Portico/getPortalConfiguration';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesGetPortalConfigurationRequestModel, "TCApiGatewayControllersModelsRequestTypesGetPortalConfigurationRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesGetProgramRequest 
     */
    public async programGetProgram (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesGetProgramRequest?: TCApiGatewayControllersModelsRequestTypesGetProgramRequest): Promise<AxiosResponse> {
        const _url_ = '/netApi/Program/getProgram';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesGetProgramRequest, "TCApiGatewayControllersModelsRequestTypesGetProgramRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async testAccount (xProgramId?: string): Promise<AxiosResponse> {
        const _url_ = '/netApi/Poc/test/account';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async testDoesThisWork (xProgramId?: string): Promise<AxiosResponse> {
        const _url_ = '/netApi/Poc/test/doesThisWork';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async testSession (xProgramId?: string): Promise<AxiosResponse> {
        const _url_ = '/netApi/Poc/test/session';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param id 
     * @param xProgramId The program id from the list of allowed program ids
     * @param pharmacyscriptV1ClientGeneratedUpdateCustomerByOrderBodyModel 
     */
    public async updateCustomerByOrderid (id: string, xProgramId?: string, pharmacyscriptV1ClientGeneratedUpdateCustomerByOrderBodyModel?: PharmacyscriptV1ClientGeneratedUpdateCustomerByOrderBodyModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/PharmacyScript/updateCustomerByOrder/{id}'
            .replace('{' + 'id' + '}', encodeURIComponent(String(id)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'id' is not null or undefined
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateCustomerByOrderid.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(pharmacyscriptV1ClientGeneratedUpdateCustomerByOrderBodyModel, "PharmacyscriptV1ClientGeneratedUpdateCustomerByOrderBodyModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
}
